import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CartService } from './cart.service';
import { AppHttpService } from '../app-http.service';

import { CartComponent } from './cart.component';
import { LotteryMainComponent } from './lottery-main/lottery-main.component';
import { SummaryComponent } from './summary/summary.component';
import { TicketSelectComponent } from './ticket-select/ticket-select.component';
import { MillionPipe } from './summary/million.pipe';
import { TicketConfComponent } from '../../../projects/configurator/src/app/ticket-select/ticket-select.component';
import { LotterySklComponent } from './lottery-skl/lottery-skl.component';
import { SummaryConfComponent } from '../../../projects/configurator/src/app/summary/summary.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { WindowRefService } from 'app/app-window.service';

@NgModule({
  declarations: [
    CartComponent,
    LotteryMainComponent,
    SummaryComponent,
    TicketSelectComponent,
    MillionPipe,
    TicketConfComponent,
    LotterySklComponent,
    SummaryConfComponent
  ],
  imports: [CommonModule, RouterModule, NgbTooltipModule],
  providers: [CartService, AppHttpService],
  exports: [CartComponent]
})
export class CartModule {}
